var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"16/search"},React.createElement("path",{"id":"Vector","d":"M12 12L16 16M8.66667 13.3333C6.08934 13.3333 4 11.244 4 8.66667C4 6.08934 6.08934 4 8.66667 4C11.244 4 13.3333 6.08934 13.3333 8.66667C13.3333 11.244 11.244 13.3333 8.66667 13.3333Z","stroke":"#A3A3A3","strokeWidth":"1.5","strokeLinecap":"square","strokeLinejoin":"round"})));
}

Search.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Search;

Search.default = Search;
